import {
  Container,
  Divider,
  Heart,
  ImageIcon,
  InnerContainer,
  LeftContainer,
  Link,
  Menu,
  NavParent,
  NavbarItem,
  RightContainer,
} from 'components/layout/Header/components';
import { Fragment, useState } from 'react';
import BrandLogo from 'components/layout/BrandLogo';
import FlexContainer from 'components/common/FlexContainer';

import SavedItemsBadge from 'components/layout/SavedItemsBadge';
import SideDrawer from 'components/layout/SideDrawer';
import Spacer from 'components/common/Spacer';
import { Spin } from 'antd';
import { StartApplicationForm } from 'components/forms/StartApplicationForm';
import useCreditBookmarks from 'hooks/use-credit-bookmarks';
import useIsMobile from 'hooks/use-is-mobile';
import useTranslation from 'hooks/use-translation';
import useURLs from 'hooks/use-url';

export default function Header(): JSX.Element {
  const translation = useTranslation();
  const urls = useURLs();
  const isMobile = useIsMobile();

  const { creditBookmarks } = useCreditBookmarks();
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);

  if (!translation || !urls) {
    return <Spin />;
  }

  let creditsSavedAriaLabel = 'No saved credit.';
  if (creditBookmarks.size === 1) {
    creditsSavedAriaLabel = '1 credit in the saved list.';
  } else if (creditBookmarks.size > 1) {
    creditsSavedAriaLabel = `${creditBookmarks.size} credits in the saved list.`;
  }

  return (
    <Fragment>
      {isMobile && <SideDrawer isOpen={drawerIsOpen} setIsOpen={setDrawerIsOpen} />}
      <Container className='header-outer-container'>
        <InnerContainer className='header-inner-container'>
          <LeftContainer>
            {isMobile && <Menu className='burger-menu-button' size={20} onClick={() => setDrawerIsOpen(true)} />}
            <BrandLogo />
          </LeftContainer>
          <RightContainer role='navigation' aria-label='navigation'>
            <NavParent className='navbar-links'>
              {!isMobile && (
                <NavbarItem>
                  <Link to='/help' className='navbar-help-link'>
                    <ImageIcon
                      className='navbar-help-icon'
                      alt=''
                      src={`./config/icons/${translation.common.icons.question.src}`}
                    />
                    <div>Help</div>
                  </Link>
                </NavbarItem>
              )}
              {!isMobile && <Divider />}
              <NavbarItem>
                <Link to='/saved-credits' className='navbar-saved-credits-link' aria-label={creditsSavedAriaLabel}>
                  <FlexContainer aria-hidden='true'>
                    <SavedItemsBadge className='navbar-saved-items-badge' count={creditBookmarks.size}>
                      {translation.common.icons.heartFilled ? (
                        <ImageIcon alt='' src={`./config/icons/${translation.common.icons.heartFilled.src}`} />
                      ) : (
                        <Heart size={20} />
                      )}
                    </SavedItemsBadge>
                  </FlexContainer>
                  {creditBookmarks.size > 0 && <Spacer size={2} type='vertical' />}
                  {!isMobile && <span className='saved-label'>Saved</span>}
                </Link>
              </NavbarItem>
              {!isMobile && (
                <Fragment>
                  <Divider className='navbar-application-button-divider' />
                  <NavbarItem>
                    <StartApplicationForm endpoint={urls.apply.url} buttonHeight={36} />
                  </NavbarItem>
                </Fragment>
              )}
            </NavParent>
          </RightContainer>
        </InnerContainer>
      </Container>
    </Fragment>
  );
}
